import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A1628] text-white pt-16 pb-8 rounded-t-3xl mt-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Main grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/b82cd702-b168-461f-af40-a8ad59f7f12d.png"
                alt="CICHORZ Logo"
                className="h-10 w-auto object-contain"
              />
              <span className="text-xl font-bold tracking-widest">CICHORZ</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mt-4 max-w-xs">
              Développement informatique et solutions digitales pour les entreprises et les particuliers à Paris.
            </p>
            <div className="mt-6 text-white/50 text-xs leading-relaxed">
              <p>Mariusz Slawomir Cichorz</p>
              <p>SIRET : 102 737 178 00016</p>
              <p>Code APE : 62.01Z – Programmation informatique</p>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xs font-semibold tracking-widest uppercase text-white/40 mb-6">Navigation</h3>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Accueil', path: '/' },
                { label: 'À propos', path: '/a-propos' },
                { label: 'Contact', path: '/contact' },
                { label: 'Conditions générales', path: '/conditions-generales' },
                { label: 'Politique de confidentialité', path: '/politique-de-confidentialite' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/70 hover:text-white text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xs font-semibold tracking-widest uppercase text-white/40 mb-6">Contact</h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-white/40">
                  <i className="ri-map-pin-line text-sm" />
                </span>
                <div className="text-white/70 text-sm leading-relaxed">
                  <p>57 Rue Lecourbe</p>
                  <p>75015 Paris, France</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-white/40">
                  <i className="ri-phone-line text-sm" />
                </span>
                <a
                  href="tel:+33758860574"
                  className="text-white/70 hover:text-white text-sm transition-colors duration-200 cursor-pointer"
                >
                  +33 7 58 86 05 74
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center text-white/40">
                  <i className="ri-mail-line text-sm" />
                </span>
                <a
                  href="mailto:mariuszcichorz@inbox.eu"
                  className="text-white/70 hover:text-white text-sm transition-colors duration-200 cursor-pointer break-all"
                >
                  mariuszcichorz@inbox.eu
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 text-white/40 text-xs">
          <p>© 2025 CICHORZ – Tous droits réservés</p>
          <div className="flex items-center gap-4">
            <Link to="/conditions-generales" className="hover:text-white/70 transition-colors cursor-pointer">
              Conditions générales
            </Link>
            <span>·</span>
            <Link to="/politique-de-confidentialite" className="hover:text-white/70 transition-colors cursor-pointer">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
